module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Thin.7a1459b4.otf";